import { injectable } from 'inversify';
import { INJECTED_TYPES, container } from '../../common';
import { IHttpService } from '../http';
import { CasePhase, CasePhaseDto, CaseStatus } from './caseStatus';
import { ICaseStatusService } from './icaseStatus.service';

@injectable()
export class CaseStatusService implements ICaseStatusService {
  private readonly apiEndpoint = '/api/product-cases';
  private _httpService = container.get<IHttpService>(INJECTED_TYPES.IHttpService);
  private buildBaseURL = (caseId: string, versionId: string) =>
    `${this.apiEndpoint}/${caseId}/treatment-plans/${versionId}/phases`;

  public async getCaseStatusPhases(caseId: string, versionId: string): Promise<CaseStatus> {
    const casePhases: CasePhaseDto = (await this._httpService.get<CasePhaseDto>(this.buildBaseURL(caseId, versionId)))
      .data;

    const caseStatus: CaseStatus = {
      id: '',
      phases: casePhases.data
    };

    return caseStatus as CaseStatus;
  }

  public async editCaseStatusPhase(caseId: string, versionId: string, casePhase: CasePhase): Promise<void> {
    await this._httpService.patch<boolean>(`${this.buildBaseURL(caseId, versionId)}/${casePhase.name}`, casePhase);
  }
}
